<template>
  <section id="targetRM">
    <v-navigation-drawer
      absolute
      temporary
      right
      v-model="drawer"
      class="pa-2"
      style="top: 50px; bottom: 120px; height: auto"
    >
      <v-row class="ma-0">
        <v-col cols="12" class="pa-0 pt-2">
          <v-autocomplete
            clearable
            :items="regionList"
            outlined
            dense
            hide-details
            label="区域"
            v-model="regionCode"
            item-text="regionName"
            item-value="regionCode"
            @change="setRegion($event)"
            v-if="isAdmin"
          ></v-autocomplete>
        </v-col>
      </v-row>
      <v-row class="ma-0">
        <v-col cols="12" class="pa-0 pt-2">
          <v-autocomplete
            outlined
            clearable
            hide-details
            dense
            label="省/直辖市 "
            :items="provinceList"
            item-value="code"
            item-text="name"
            @change="setProvince($event)"
            v-model="provinceCode"
          ></v-autocomplete>
        </v-col>
      </v-row>
      <v-row class="ma-0">
        <v-col cols="12" class="pa-0 pt-2">
          <v-autocomplete
            outlined
            clearable
            hide-details
            dense
            label="市"
            :items="cityList"
            item-value="code"
            item-text="name"
            @change="setCity($event)"
            v-model="cityCode"
          ></v-autocomplete>
        </v-col>
      </v-row>
      <v-row class="ma-0" v-if="!this.user.role?.includes('Sales')">
        <v-col cols="12" class="pa-0 pt-2">
          <v-autocomplete
            :items="salesList"
            outlined
            hide-details
            clearable
            dense
            label="销售姓名"
            item-value="id"
            item-text="displayName"
            v-model="salesId"
          ></v-autocomplete>
        </v-col>
      </v-row>
      <template v-slot:append>
        <v-row class="ma-0">
          <v-btn class="primary white--text" @click="clearTargetListSearch()"
            >清空搜索</v-btn
          >
          <v-spacer></v-spacer>
          <v-btn class="primary white--text" @click="getTargetList()"
            >搜索</v-btn
          >
        </v-row>
      </template>
    </v-navigation-drawer>
    <v-form class="ma-2 mb-0">
      <v-row class="ma-0">
        <div class="breadcrumb font-weight-black">
          {{ breadcrumb }}
        </div>
        <v-spacer></v-spacer>
        <v-btn color="primary" dark @click.stop="drawer = !drawer">
          筛选
        </v-btn>
        <v-btn
          v-if="!this.user.role?.includes('Sales')"
          class="success white--text ml-2"
          @click="openAdd"
          >设置目标</v-btn
        >
      </v-row>
    </v-form>
    <div
      id="targetCharts"
      class="pb-2"
      :class="{
        isSale: user.role?.includes('Sales') || user.role?.includes('Sell-in Sales'),
      }"
    >
      <p class="subtitle-1 font-weight-bold px-2 my-1">经销商目标管理</p>
      <v-card height="200" class="mt-2 mx-2">
        <v-simple-table style="height: 145px">
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left" style="width: 90px"></th>
                <th class="text-left">开发目标</th>
                <th class="text-left">YTD开发数量</th>
                <th class="text-left">完成率</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in dealer" :key="item.targetId">
                <td>{{ item.targetName }}</td>
                <td>{{ item.targetValue }}</td>
                <td>{{ item.actualValue }}</td>
                <td>{{ item.finishRate }}</td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="redirectTo('/distributor/list')"
            >查看详情</v-btn
          >
        </v-card-actions>
      </v-card>
      <p class="subtitle-1 font-weight-bold px-2 my-1">门店目标管理</p>
      <v-card height="340" class="mt-2 mx-2">
        <v-simple-table style="height: 288px">
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left" style="width: 45px"></th>
                <th class="text-left">开发目标</th>
                <th class="text-left">YTD开发数量</th>
                <th class="text-left">完成率</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in store" :key="item.targetId">
                <td>{{ item.targetName }}</td>
                <td>{{ item.targetValue }}</td>
                <td>{{ item.actualValue }}</td>
                <td>{{ item.finishRate }}</td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="redirectTo('/store/list')"
            >查看详情</v-btn
          >
        </v-card-actions>
      </v-card>
    </div>
    <!-- <v-row class="ma-0 pt-2" v-if="!this.user.role?.includes('Sales')">
      <v-spacer></v-spacer>
      <v-btn outlined tile v-if="!this.user.role?.includes('Sales')" class="success white--text mr-2" @click="openAdd"
        >设置目标</v-btn
      >
    </v-row> -->
    <v-dialog v-model="addDialog" persistent>
      <v-card>
        <v-card-title>
          <span class="v-size--default red--text text--darken-1">(新增:填写全部信息,再保存)</span>
          <span class="v-size--default red--text text--darken-1">(修改:先搜索,修改,再保存)</span>
        </v-card-title>
        <v-card-text class="pb-0" style="overflow: auto; height: 450px">
          <v-form class="px-4 pt-2" ref="form" v-model="valid" lazy-validation>
            <v-text-field
              :rules="[(v) => !!v || '这是必填项']"
              outlined
              clearable
              required
              dense
              label="年份"
              type="number"
              v-model="payload.targetYear"
            ></v-text-field>
            <v-autocomplete
              clearable
              :items="regionList"
              outlined
              :rules="[(v) => !!v || '这是必填项']"
              dense
              label="区域"
              v-model="payload.region"
              item-text="regionName"
              return-object
              @change="setRegionAdd($event.regionCode)"
              v-if="isAdmin"
            ></v-autocomplete>
            <v-autocomplete
              outlined
              clearable
              dense
              label="省/直辖市 "
              :items="provinceListAdd"
              item-value="code"
              :rules="[(v) => !!v || '这是必填项']"
              item-text="name"
              return-object
              v-model="payload.province"
              @change="setProvinceAdd($event.code)"
            ></v-autocomplete>
            <v-autocomplete
              outlined
              clearable
              dense
              label="市"
              :items="cityListAdd"
              return-object
              item-text="name"
              v-model="payload.city"
            ></v-autocomplete>
            <v-autocomplete
              :items="salesList"
              outlined
              clearable
              dense
              :rules="[(v) => !!v || '这是必填项']"
              label="销售姓名"
              item-value="id"
              item-text="displayName"
              v-model="payload.salesId"
            ></v-autocomplete>
            <v-row>
              <v-spacer></v-spacer>
              <v-btn color="primary darken-1" @click="searchTarget">
                搜索
              </v-btn>
            </v-row>
            <p class="subtitle-1 font-weight-bold">经销商目标</p>
            <v-text-field
              v-for="item in dealerTarget"
              :key="item.targetName"
              outlined
              clearable
              required
              dense
              :label="item.targetName"
              type="number"
              v-model="item.targetValue"
            ></v-text-field>
            <p class="subtitle-1 font-weight-bold">门店目标</p>
            <v-text-field
              v-for="item in storeTarget"
              :key="item.targetName"
              outlined
              clearable
              required
              dense
              :label="item.targetName"
              type="number"
              v-model="item.targetValue"
            ></v-text-field>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" text @click="addDialog = false">
            关闭
          </v-btn>
          <v-btn color="blue darken-1" text @click="saveTarget"> 保存 </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar
      :timeout="5000"
      :value="message.show"
      absolute
      top
      :color="message.type"
      style="z-index: 9999"
    >
      <v-alert :type="message.type" class="mb-0"> {{ message.text }} </v-alert>
      <template v-slot:action="{ attrs }">
        <v-btn color="white" text v-bind="attrs" @click="message.show = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </template>
    </v-snackbar>
    <v-overlay :value="loading" style="z-index: 999">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </section>
</template>

<script>
import { mapState } from "vuex";
import api from "../../api/api";
import { mapActions } from "vuex";
export default {
  name: "TargetForRM",
  computed: {
    ...mapState(["user"]),
    isAdmin() {
      return this.user.role?.includes('HOD') || this.user.role?.includes('RRS') || this.user.role?.includes('SCN');
    },
  },
  data: () => ({
    breadcrumb: "",
    drawer: false,
    loading: false,
    message: {
      show: false,
      type: "success",
      text: "",
    },
    provinceList: [],
    cityList: [],
    salesList: [],
    targetList: [],
    items: ["foo", "bar", "fizz", "buzz"],
    dealer: [],
    store: [],
    addDialog: false,
    salesId: "",
    provinceCode: "",
    cityCode: "",
    regionCode: "",
    regionName: "",
    provinceListAdd: [],
    cityListAdd: [],
    salesListAdd: [],
    valid: false,
    payload: {
      regionCode: "",
      regionName: "",
      region: null,
      provinceCode: "",
      province: "",
      provinceName: "",
      city: "",
      cityCode: "",
      cityName: "",
      salesId: null,
      target: null,
      targetId: null,
      targetName: null,
      targetValue: null,
      targetYear: null,
    },
    dealerTarget: [],
    storeTarget: [],
    regionList: [],
  }),

  created() {
    this.loading = true;
    this.getRegion();

    this.getTargetTypeList();
  },
  // mounted() {

  // },
  watch: {
    addDialog(val) {
      if (!val) {
        this.dealerTarget = this.dealerTarget.map((i) => {
          return {
            ...i,
            id: null,
          };
        });
        this.storeTarget = this.storeTarget.map((i) => {
          return {
            ...i,
            id: null,
          };
        });
        this.$refs.form.reset();
      }
    },
  },
  methods: {
    ...mapActions(["SET_BACK"]),
    redirectTo(path) {
      let developmentStatus = 26;
      this.$router.push({
        path,
        query: {
          region: this.regionCode,
          province: this.provinceCode,
          city: this.cityCode,
          salesId: this.salesId,
          year: new Date().getFullYear(),
          developmentStatus: developmentStatus,
        },
      });
    },
    searchTarget() {
      if (!this.$refs.form.validate()) return;
      this.loading = true;
      const payload = {
        salesId: this.payload.salesId,
        provinceCode: this.payload.province.code,
        cityCode: this.payload.city?.code,
        regionCode: this.payload.region?.regionCode,
        targetYear: Number(this.payload.targetYear),
      };
      api.target
        .getTargetListWithFilter(payload)
        .then((res) => {
          const { status, data } = res?.data || {};
          if (status == 200 && data?.list.length > 0) {
            this.dealerTarget = this.dealerTarget.map((tar) => {
              let targetValue = null;
              let id = null;
              const setted = data.list.filter((i) => {
                return i.targetId === tar.targetId;
              });
              if (setted.length) {
                targetValue = setted[0].targetValue;
                id = setted[0].id;
              }
              return { ...tar, targetValue, id };
            });
            this.storeTarget = this.storeTarget.map((tar) => {
              let targetValue = null;
              let id = null;
              const setted = data.list.filter((i) => {
                return i.targetId === tar.targetId;
              });
              if (setted.length) {
                id = setted[0].id;
                targetValue = setted[0].targetValue;
              }
              return { ...tar, targetValue, id };
            });
          } else if (status == 200 && !data?.list?.length) {
            this.dealerTarget = this.dealerTarget.map((i) => {
              return {
                ...i,
                targetValue: null,
              };
            });
            this.storeTarget = this.storeTarget.map((i) => {
              return {
                ...i,
                targetValue: null,
              };
            });
            this.message = {
              show: true,
              type: "info",
              text: "没有查询到目标，请设置！",
            };
          } else {
            this.message = {
              show: true,
              type: "error",
              text: "没有目标数据！",
            };
          }
        })
        .catch((err) => {
          console.log(err);
          this.message = {
            show: true,
            type: "error",
            text: "数据加载失败，请重试！",
          };
        })
        .finally(() => {
          this.loading = false;
          this.drawer = false;
          setTimeout(() => {
            this.message.show = false;
          }, 5000);
        });
    },
    saveTarget() {
      if (!this.$refs.form.validate()) return;
      this.loading = true;
      const payload = [...this.dealerTarget, ...this.storeTarget].map(
        (item) => {
          return {
            ...item,
            targetValue: Number(item.targetValue || 0),
            salesId: this.payload.salesId,
            targetYear: Number(this.payload.targetYear),
            provinceCode: this.payload.province?.code,
            provinceName: this.payload.province?.name,
            regionCode: this.payload.region?.regionCode,
            regionName: this.payload.region?.regionName,
            cityCode: this.payload.city?.code,
            cityName: this.payload.city?.name,
          };
        }
      );
      api.target
        .addBatchTarget(payload)
        .then((res) => {
          if (res.data.status == 200) {
            this.message = {
              show: true,
              type: "success",
              text: "保存成功！",
            };
            this.$refs.form.reset();
            this.addDialog = false;
          } else {
            if(res.data.messageKey && "DATA_INTEGRITY_VIOLATION" == res.data.messageKey){
              this.message = {
              show: true,
              type: "error",
              text: "数据已存在,请先搜索",
            };
            }else{
              this.message = {
              show: true,
              type: "error",
              text: "保存失败，请重试！",
            };
            }
          }
        })
        .catch(() => {
          this.message = {
            show: true,
            type: "error",
            text: "保存失败，请重试！",
          };
        })
        .finally(() => {
          this.loading = false;
          setTimeout(() => {
            this.message.show = false;
          }, 5000);
        });
    },
    openAdd() {
      this.addDialog = true;
    },
    setRegion($event) {
      if ($event) {
        const selectedRegion = this.regionList.filter(
          (i) => i.regionCode == $event
        )[0];
        this.getProvince(selectedRegion?.provinces);
        this.regionName = selectedRegion.regionName;
        this.getSaleList();
      } else {
        this.provinceList = [];
      }
    },
    setRegionAdd($event) {
      if ($event) {
        const selectedRegion = this.regionList.filter(
          (i) => i.regionCode == $event
        )[0];
        this.provinceListAdd = api.pca.getProvince().filter((i) => {
          return (
            selectedRegion?.provinces?.filter(
              (pro) => pro.provinceCode === i.code
            ).length > 0
          );
        });

        this.getSaleListAdd($event);
      } else {
        this.provinceListAdd = [];
        this.salesListAdd = [];
      }
      this.cityListAdd = [];
      this.payload.city = null;
      this.payload.province = null;
      this.payload.salesId = null;
    },
    setRegionForInit($event) {
      if ($event) {
        const selectedRegion = this.regionList.filter(
          (i) => i.regionCode == $event
        )[0];
        this.getProvince(selectedRegion?.provinces);
        this.regionName = selectedRegion.regionName;
      } else {
        this.provinceList = [];
      }

      this.regionCode = this.$route.query.region || "";
      this.provinceCode = this.$route.query.province || "";
      this.cityCode = this.$route.query.city || "";
      this.salesId = this.$route.query.salesId || "";
      if (this.salesId) {
        this.salesId = Number(this.salesId);
      }
      if (this.provinceCode) {
        this.cityList = api.pca.getCityByProvince(this.provinceCode);
      } else {
        this.cityList = [];
      }
    },
    getRegion() {
      api.pca
        .getRegion()
        .then((res) => {
          const { data, status } = res.data;
          if (status == 200 && data) {
            this.regionList = data;
            if (
              Object.prototype.hasOwnProperty.call(
                this.$route.query,
                "region"
              ) ||
              Object.prototype.hasOwnProperty.call(this.$route.query, "salesId")
            ) {
              this.regionCode = this.$route.query.region || "";
              this.setRegionForInit(this.regionCode);
            } else if (!this.isAdmin) {
              this.setRegion(this.user.userRegionCode);
              if (this.user.role?.includes('Sales')) {
                this.salesId = this.user.userId;
              }
              this.regionCode = this.user.userRegionCode;
            }
            this.getTargetList();
            this.getSaleList();
          }
        })
        .finally(() => {});
    },
    getProvince(byRegion) {
      if (byRegion) {
        this.provinceList = api.pca.getProvince().filter((i) => {
          return (
            byRegion.filter((pro) => pro.provinceCode === i.code).length > 0
          );
        });
        this.provinceListAdd = this.provinceList;
      } else {
        this.provinceList = api.pca.getProvince();
        this.provinceListAdd = api.pca.getProvince();
      }
    },
    setProvince($event) {
      this.cityList = api.pca.getCityByProvince($event);
      this.cityCode = null;
    },
    setProvinceAdd($event) {
      this.payload.city = null;
      this.cityListAdd = api.pca.getCityByProvince($event);
    },
    setCity() {
      // this.getSaleList();
    },
    getTargetTypeList() {
      api.common.getTarget().then((res) => {
        const { data, status } = res.data;
        if (status == 200 && data) {
          this.targetList = data.list;
          this.dealerTarget = this.targetList
            .filter((i) => i.type === "dealer_target")
            .map((i) => {
              return {
                targetId: i.id,
                targetName: i.name,
                targetType: i.type,
              };
            });
          this.storeTarget = this.targetList
            .filter((i) => i.type === "store_target")
            .map((i) => {
              return {
                targetId: i.id,
                targetName: i.name,
                targetType: i.type,
              };
            });
        }
      });
    },
    getSaleList() {
      api.user
        .getUserWithRoleAndRegion("Sales", this.regionCode, "Sell-in Sales")
        .then((res) => {
          const { data, status } = res.data;
          if (status == 200 && data) {
            this.salesList = data;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getSaleListAdd(regionCode) {
      api.user
        .getUserWithRoleAndRegion("Sales", regionCode, "Sell-in Sales")
        .then((res) => {
          const { data, status } = res.data;
          if (status == 200 && data) {
            this.salesList = data;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    clearTargetListSearch(){
      if (this.isAdmin) {
        this.regionCode = null; 
      }

      if (!this.user.role?.includes('Sales')) {
        this.salesId = null;
      }
      this.provinceCode = null;
      this.cityCode = null;
      this.getTargetList();
    },
    getTargetList() {
      // if (
      //   !this.regionCode &&
      //   !this.provinceCode &&
      //   !this.cityCode &&
      //   !this.salesId
      // ) {
      //   this.message = {
      //     show: true,
      //     type: "info",
      //     text: "请选择筛选条件！",
      //   };
      //   setTimeout(() => {
      //     this.message.show = false;
      //   }, 5000);
      //   return;
      // }
      this.loading = true;
      api.target
        .getTargetList(
          `?salesId=${this.salesId || ""}&provinceCode=${
            this.provinceCode || ""
          }&cityCode=${this.cityCode || ""}&regionCode=${
            this.regionCode || ""
          }&year=${new Date().getFullYear()}`
          // `?salesId=${this.user.userId}&year=${new Date().getFullYear()}`
        )
        .then((res) => {
          const { status, data } = res.data;
          if (status == 0 && data.length) {
            this.dealer = data
              .filter((i) => i.targetId == 1 || i.targetId == 2)
              .map((i) => {
                return {
                  ...i,
                  // finishRate: i.finishRate * 100 + "%",
                };
              });
            const store = data.filter(
              (i) =>
                i.targetId == 3 ||
                i.targetId == 4 ||
                i.targetId == 5 ||
                i.targetId == 6 ||
                i.targetId == 0
            );
            // const totalTarget = store
            //   .map((i) => i.targetValue)
            //   .reduce((total, next) => total + next);
            // const totalActual = store
            //   .map((i) => i.actualValue)
            //   .reduce((total, next) => total + next);
            // store.push({
            //   actualValue: totalActual,
            //   // finishRate: totalActual / totalTarget,
            //   targetId: 7,
            //   targetName: "合计",
            //   targetValue: totalTarget,
            // });
            this.store = store.map((i) => {
              return {
                ...i,
                // finishRate: i.finishRate * 100 + "%",
              };
            });
          } else {
            this.message = {
              show: true,
              type: "info",
              text: "没有数据！",
            };
            this.dealer = [];
            this.store = [];
          }
        })
        .catch((err) => {
          console.log(err);
          this.message = {
            show: true,
            type: "error",
            text: "数据加载失败，请重试！",
          };
        })
        .finally(() => {
          this.loading = false;
          setTimeout(() => {
            this.message.show = false;
          }, 5000);
        });
    },
  },
};
</script>

<style lang="sass">
#targetRM
  height: 100%
  width: 100%
  .breadcrumb
    line-height: 36px
  #targetCharts
    height: calc( 100% - 50px )
    width: 100%
    overflow: auto
  #targetCharts.isRM
    height: calc( 100% - 200px )
  #targetCharts.isSale
    height: calc( 100% - 50px )
</style>
